import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-05/lesson-13/task-01";

const task: Slide = {
  titleHtml:
    "In a restaurant, assuming that it is always fully occupied, the noise levels are very high<br>due to a large number of speakers. This is disturbing and does not match the wishes of the owner.<br>To reduce noise levels in this restaurant the designer/acoustician should recommend...",
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
